<template>


  <div class="row m-0" style="direction: ltr">
    <div class="col-12 col-lg-4 offset-lg-2 d-none d-lg-flex">

      <img class="desktop-form-wizard-img" :src="this.base_setting[this.chart_type]['desktop_img']" alt="">


    </div>


    <div class="col-12 col-lg-4 order-1 p-0">




    <div class="wizard-form">

      <div v-if="step !== 5" class="w-100 text-right hora-steps-text border-0">
        <div v-html="stepText()"></div>
      </div>

      <div v-if="step === 1" class="w-100">
        <div class="step">
              <div class="hora-form-step">
                <div class="hora-form-name mb-6">
                  <div class="flex flex-row items-center gap-2.5 mb-6">
                    <h3 class="labels-input">نام شما</h3>
                  </div>
                  <div class="mb-3">

                    <div class="input-wrapper">
                      <input
                          :style="errors.name_error === 'block' ? { border: '1px solid #EC221F !important', background: '#FEE8E7 !important' } : {}"
                          id="name"
                          v-model="chart_request.title"
                          name="name"
                          placeholder="نام خود را وارد نمایید"
                          type="text"
                          class="custom-input"
                      />
                    </div>

                  </div>
                </div>

                <div class="hora-form-gender mt-6 mb-6">
                  <div class="flex flex-row items-center gap-2.5">
                    <h5 class="labels-input">جنسیت</h5>
                  </div>
                  <div class="mt-6">



                    <div class="select-wrapper">
                      <select
                          :style="errors.name_error === 'block' ? { border: '1px solid #EC221F !important', background: '#FEE8E7 !important' } : {}"
                          v-model="chart_request.gender" name="gender" id="gender" class="custom-select">
                        <option value="null" disabled>جنسیت</option>
                        <option value="0">زن</option>
                        <option value="1">مرد</option>
                        <option value="2">non-binary/other</option>
                      </select>
                      <div class="select-icon">
                        <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L9.5 11L18 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
              <div class="hora-form-buttons">
                <a target="_blank"
                   :href="`${this.site_url}/privacy-policy`"
                   class="hora_policy" disabled>

                  <span>سیاست حریم شخصی</span>

                  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" width="17" height="17" rx="8.5" fill="#ECE2AB"/>
                    <path d="M8.08105 15.5408V6.03979H10.3311V15.5408H8.08105ZM7.8877 3.42944C7.8877 3.07202 8.01367 2.79077 8.26562 2.58569C8.52344 2.37476 8.83105 2.26929 9.18848 2.26929C9.55762 2.26929 9.86816 2.37476 10.1201 2.58569C10.3779 2.79077 10.5068 3.07202 10.5068 3.42944C10.5068 3.78101 10.3779 4.06226 10.1201 4.27319C9.86816 4.48413 9.55762 4.5896 9.18848 4.5896C8.83105 4.5896 8.52344 4.48413 8.26562 4.27319C8.01367 4.06226 7.8877 3.78101 7.8877 3.42944Z" fill="#0E1D54"/>
                  </svg>

                </a>
                <a id="nextStep01" @click="nextStep"  class="hora-next-btn">
                  <span class="">  برو بعدی</span>

                </a>
              </div>


        </div>
      </div>

      <div v-if="step === 2" class="w-100">
        <div class="step" id="step-2">

              <div class="hora-form-step">
                <div class="hora-form-date mb-10">

                  <div class="mt-6">
                    <DatePicker
                      :date_error_m="this.errors.date_error_m"
                      :date_error_y="this.errors.date_error_y"
                      :date_error_d="this.errors.date_error_d"
                      :limit_future_range="this.base_setting[this.chart_type]['limit_future_range']"
                      :limit_under_18y="this.base_setting[this.chart_type]['limit_under_18y']"
                      :custom_number_en="this.base_setting[this.chart_type]['custom_number_en']"
                      :custom_number_fa="this.base_setting[this.chart_type]['custom_number_fa']"
                      @updateValidaDateVar="updateValidDate"
                      @updateDatePickerForm="updateFormDate"
                    ></DatePicker>

                  </div>
                </div>
              </div>
              <div class="hora-form-buttons">
                <a @click="previousStep" class="back_btn" disabled>
                  <span> بازگشت</span>
                </a>
                <a id="nextStep01" @click="nextStep"  class="hora-next-btn">
                  <span>  برو بعدی</span>
                </a>
              </div>

        </div>
      </div>

      <div v-if="step === 3" class="w-100">
        <div class="step " id="step-3">

              <div class="hora-form-step">
                <div class="hora-form-clock mb-10">
                  <div class="flex flex-row items-center gap-2.5">
                    <h3 class="labels-input">ساعت تولد</h3>
                  </div>
                  <div class="mt-6">
                    <TimePicker
                        @updateTimePickerForm="updateFormTime"
                        :time_error_h="this.errors.time_error_h"
                        :time_error_m="this.errors.time_error_m"
                    ></TimePicker>

                  </div>


                  <div v-if="this.base_setting[this.chart_type]['age_unknown_show_checkbox']" style="margin-top: 2rem; display: flex; align-items: center;">
                    <input
                        id="check"
                        name="check"
                        type="checkbox"
                        style="margin-left: 0.75rem; height: 1rem; width: 1rem; border-radius: 0.25rem; border: 1px solid #cbd5e1; color: #64748b; outline: none; box-shadow: 0 0 0 2px transparent; transition: box-shadow 0.2s;"
                        onfocus="this.style.boxShadow = '0 0 0 2px #64748b';"
                        onblur="this.style.boxShadow = '0 0 0 2px transparent';">
                    <label
                        for="check"
                        style="color: #64748b; line-height: 2.5rem;">
                      ساعت تولدم ممکن است کاملا دقیق نباشد.
                    </label>
                  </div>

                </div>
              </div>
              <div class="hora-form-buttons">
                <a  @click="previousStep" class="back_btn" disabled>

                  <span>  بازگشت</span>
                </a>
                <a  id="nextStep01" @click="nextStep"  class="hora-next-btn">
                  <span>  برو بعدی</span>
                </a>
              </div>
        </div>
      </div>


      <div v-if="step === 4" class="w-100">
        <div class="step" id="step-4">
              <div class="hora-form-step">
                <div class="hora-form-city mb-6">

                  <div class="mt-6">
                    <div class="relative">
                      <div class="city_selector">


                        <autocomplete
                            :style="`
                            display: block;
                            width: 100%;
                            border: ${errors.location_error} 1px solid;
                            background: ${errors.location_error === '#EC221F' ? '#FEE8E7' : '#F7F9FF'} !important;
                            border-radius: 8px;
                            outline: none;
                            box-shadow: none;
                          `"
                            aria-label="جستجوی موقعیت جغرافیایی"
                            placeholder="شهر محل تولد"
                            :search="search"
                            :get-result-value="getResultValue"
                            @submit="handleSubmit"
                            id="location-autocomplete"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="hora-form-time-zone mt-6 mb-6">
                  <p class="m-0">منطقه زمانی به طور خودکار براساس مکان تولد محاسبه شده است.</p>
                  <TimezoneSelector
                    :input_disabled="auto_timezone"
                    :default_input="chart_request.timezone"
                  ></TimezoneSelector>
                </div>
              </div>
              <div class="hora-form-buttons">
                <a @click="previousStep" class="back_btn" disabled>

                  <span>  بازگشت</span>
                </a>
                <a id="nextStep01" @click="nextStep"  class="hora-next-btn">
                  <span>  برو بعدی</span>
                </a>
              </div>

        </div>
      </div>

      <div v-if="step === 5" class="w-100">
        <ChartModal :chartRequest="chart_request" @submit-chart="submitChart" @previousStep="previousStep"/>
      </div>


      <div class="steps_hora" id="steps_hora">
        <div
            v-for="n in 4"
            :key="n"
            class="step_hora"
            :class="{ active: n === step || (n === 4 && step === 5) }"
            :data-step="n"
        ></div>
      </div>

    </div>

    </div>
  </div>
    <Loading :is-loading="isLoading" />

</template>

<script>
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import ApiService from "../service/api";
import DSTSelector from "./DSTSelector.vue";
import TimezoneSelector from "./TimezoneSelector.vue";

import HelperLib from "./helper";
import Loading from "./Loading.vue";
import HoraStats from "./HoraStats.vue";
import ChartModal from "./ChartModal.vue";
import jalaali from 'jalaali-js';

export default {
  name: "ReportForm",
  components: {
    ChartModal, HoraStats,
    Loading,
    DatePicker,
    Autocomplete,
    TimezoneSelector,
    DSTSelector,
    TimePicker,
  },
  props: {
    t_year: null,
    t_month: null,
    t_day: null,
    t_hour: null,
    t_min: null,
    t_sec: null,
  },
  data() {
    return {
      auto_location: true,
      auto_timezone: true,
      only_county: false,
      isLoading: false,
      step: 1,
      errors: {
        name_error: "none",
        gender_error: "none",
        time_error_h: false,
        time_error_m: false,
        date_error_y: false,
        date_error_m: false,
        date_error_d: false,
        location_error: "#0E1D54",
      },

      dms_error: false,
      input_lat_min: "",
      input_lat_deg: "",
      input_lat_min_sign: "",
      input_lat_dir: "",
      input_lon_min: "",
      input_lon_deg: "",
      input_lon_dir: "",
      input_lon_min_sign: "",

      lat_loc_deg_range: this.getRange(0, 90),
      lat_loc_dir: ["N", "S"],
      lat_loc_min_range: this.getRange(0, 60),

      lat_dir_search: null,
      lat_deg_search: null,
      lat_min_search: null,

      lon_loc_deg_range: this.getRange(0, 180),
      lon_loc_dir: ["E", "W"],
      lon_loc_min_range: this.getRange(0, 60),

      lon_dir_search: null,
      lon_deg_search: null,
      lon_min_search: null,

      is_advance_form: false,
      datepicker_column: {
        576: 1,
        992: 2,
      },
      chart_request: {
        title: "",
        display_loc: '',
        latitude: null,
        longitude: null,
        altitude: null,
        year: null,
        gender: null,
        month: null,
        day: null,
        hour: null,
        min: null,
        sec: null,
        timezone: null,
        city: null,
        state: null,
        country: null,
        tz_country: null,
        date_type: null,
        dasha_date_type: null,
        vargas: null,
        nesting: null,
        t_date_type: null,
        dst_min: "0",
        dst_hour: "0",
        lat_deg: null,
        lat_min: null,
        lat_sec: null,
        lat_dir: null,
        lon_deg: null,
        lon_min: null,
        lon_sec: null,
        lon_dir: null,
      },
      site_url: null,
      chart_result: Object,

      chart_type : "",
      //career , wealth , health , talent , mmt , premium , love
      base_setting : {
        "career":{ //done
          "limit_future_range": true,
          "limit_under_18y": false,
          "custom_number_en":"2024",
          "custom_number_fa":"1403",
          "age_unknown_show_checkbox": false,
          "desktop_img":"https://horastro.co/wp-content/uploads/2024/12/43f3f592cefebdb3acf1e0d941cdf830-scaled.jpeg",
        },
        "wealth":{ //done
          "limit_future_range": true,
          "limit_under_18y": false,
          "custom_number_en":"2024",
          "custom_number_fa":"1403",
          "age_unknown_show_checkbox": false,
          "desktop_img":"https://horastro.co/wp-content/uploads/2024/12/43f3f592cefebdb3acf1e0d941cdf830-scaled.jpeg",
        },
        "health":{ //done
          "limit_future_range": true,
          "limit_under_18y": false,
          "custom_number_en":"2024",
          "custom_number_fa":"1403",
          "age_unknown_show_checkbox": false,
          "desktop_img":"https://horastro.co/wp-content/uploads/2024/12/43f3f592cefebdb3acf1e0d941cdf830-scaled.jpeg",
        },
        "talent":{ //done
          "limit_future_range": true,
          "limit_under_18y": false,
          "custom_number_en":"2024",
          "custom_number_fa":"1403",
          "age_unknown_show_checkbox": false,
          "desktop_img":"https://horastro.co/wp-content/uploads/2024/12/43f3f592cefebdb3acf1e0d941cdf830-scaled.jpeg",
        },
        "mmt":{ //done
          "limit_future_range":true,
          "limit_under_18y":true,
          "custom_number_en":"2024",
          "custom_number_fa":"1403",
          "age_unknown_show_checkbox": false,
          "desktop_img":"https://horastro.co/wp-content/uploads/2024/12/43f3f592cefebdb3acf1e0d941cdf830-scaled.jpeg",
        },
        "premium":{
          "limit_future_range": true,
          "limit_under_18y": false,
          "custom_number_en":"2024",
          "custom_number_fa":"1403",
          "age_unknown_show_checkbox": true,
          "desktop_img":"https://horastro.co/wp-content/uploads/2024/12/43f3f592cefebdb3acf1e0d941cdf830-scaled.jpeg",
        },
        "love":{ //done
          "limit_future_range": true,
          "limit_under_18y": false,
          "custom_number_en":"2024",
          "custom_number_fa":"1403",
          "age_unknown_show_checkbox": false,
          "desktop_img":"https://horastro.co/wp-content/uploads/2024/12/43f3f592cefebdb3acf1e0d941cdf830-scaled.jpeg",
        },
      },
      wizardSteps: {
        1: '',
        2: '',
        3: '',
        4: ''
      },
    };
  },

  mounted: function() {
    this.loadSettings_birth_hints();
    this.site_url = process.env.BASE_URL;
  },

  created () {
    const element = document.querySelector('.vue-get-form-view');
    const dataType = element.getAttribute('data-type');
    this.chart_type = dataType;
  },
  watch: {

    input_lat_min: function (value) {
      if (value.charAt(0) === "-" && value.length > 3) {
        this.input_lat_min = value.substring(1, 3);
      }
      if (value.charAt(0) !== "-" && value.length > 2) {
        this.input_lat_min = value.substring(0, 2);
      }
      const regex = /^0?[0-9]|[1-5][0-9]$/;
      if (!regex.test(value) && value) {
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lat_min = this.input_lat_min;
      }
    },
    input_lat_deg: function (value) {
      if (value.length > 3) {
        this.input_lat_deg = value.substring(0, 3);
      }
      const regex = /^(?:\d{1,2}|1[0-7]\d|180)$/;
      if (!regex.test(value) && value) {
        this.input_lat_deg = value.substring(0, 3);
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lat_deg = this.input_lat_deg;
      }
    },

    input_lon_min: function (value) {
      if (value.charAt(0) === "-" && value.length > 3) {
        this.input_lon_min = value.substring(1, 3);
      }
      if (value.charAt(0) !== "-" && value.length > 2) {
        this.input_lon_min = value.substring(0, 2);
      }
      const regex = /^0?[0-9]|[1-5][0-9]$/;
      if (!regex.test(value) && value) {
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lon_min = this.input_lon_min;
      }
    },
    input_lon_deg: function (value) {
      if (value.length > 3) {
        this.input_lon_deg = value.substring(0, 3);
      }
      const regex = /^(?:\d{1,2}|1[0-7]\d|180)$/;
      if (!regex.test(value) && value) {
        this.input_lon_deg = value.substring(0, 3);
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lon_deg = this.input_lon_deg;
      }
    },

  },
  methods: {



    loadSettings_birth_hints: function() {
      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_birth_chart_hints',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.wizardSteps = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });
    },
    stepText() {
      switch (this.step) {
        case 1:
          return this.wizardSteps['1'];
        case 2:
          return this.wizardSteps['2'];
        case 3:
          return this.wizardSteps['3'];
        case 4:
          return this.wizardSteps['4'];
        default:
          return '';
      }
    },
    nextStep() {
      if (this.step === 1) {
        if (
          this.chart_request.title === "" ||
          String(this.chart_request.title).length < 3
        ) {
          this.errors.name_error = "block";
        }
        if (this.chart_request.title != "" && String(this.chart_request.title).length > 1) {
          this.errors.name_error = "none";
        }
        if (this.chart_request.gender === null) {
          this.errors.gender_error = "block";
        }
        if (this.chart_request.gender != null) {
          this.errors.gender_error = "none";
        }
        if (this.chart_request.gender === null || this.chart_request.title === "") {
          return;
        }

      } else if (this.step === 2) {

        if (this.chart_request.year === null) {
          this.errors.date_error_y = true;
        }

        if (this.chart_request.year != null) {
          this.errors.date_error_y = false;
        }
        //////////////////day
        if (this.chart_request.day === null) {
          this.errors.date_error_d = true;
        }

        if (this.chart_request.day != null) {
          this.errors.date_error_d = false;
        }
        //////////////////////month
        if (this.chart_request.month === null) {
          this.errors.date_error_m = true;
        }

        if (this.chart_request.month != null) {
          this.errors.date_error_m = false;
        }
        /////////////////////

        if (
          this.chart_request.year === null
        ) {
          return;
        }
      }
      else if (this.step === 3) {


        var hour = this.chart_request.hour ? this.chart_request.hour.length : 0;

        var min =  this.chart_request.min ? this.chart_request.min.length : 0

        if (
          hour === 0
        ) {
          this.errors.time_error_h = true;
        }

        if (hour !== 0) {
          this.errors.time_error_h = false;
        }


        if (
          min === 0
        ) {
          this.errors.time_error_m = true;
        }

        if (min !== 0) {
          this.errors.time_error_m = false;
        }




        if (
          hour === 0 || min === 0
        ) {
          return;
        }


      }

      else if (this.step === 4) {

        if (this.chart_request.longitude == null) {
          this.errors.location_error = "#EC221F";
        }
        if (
          this.chart_request.longitude === null
        ) {
          return;
        }
      }
      if (this.step < 5) {
        this.step++;
      }
    },
    previousStep() {
      if (this.step > 1) {
        this.step--;
      }
    },

    getRange(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i.toString());
      }
      return result;
    },
    updateFormDate(year, month, day, date_type) {
      this.chart_request.year = year;
      this.chart_request.month = month;
      this.chart_request.day = day;
      this.chart_request.date_type = date_type;
    },
    updateFormTime(hour, min, sec) {
      this.chart_request.hour = hour;
      this.chart_request.min = min;
      this.chart_request.sec = sec;
    },
    updateFormTimezone(tz) {
      // console.log("TEST", tz)
      this.chart_request.timezone = tz;
    },
    updateDSToffset(dst_value) {
      switch (dst_value) {
        case "0":
          this.chart_request.dst_hour = "0";
          this.chart_request.dst_min = "0";
          break;
        case "1":
          this.chart_request.dst_hour = "0";
          this.chart_request.dst_min = "30";
          break;
        case "2":
          this.chart_request.dst_hour = "1";
          this.chart_request.dst_min = "0";
          break;
        case "3":
          this.chart_request.dst_hour = "1";
          this.chart_request.dst_min = "30";
          break;
        case "4":
          this.chart_request.dst_hour = "2";
          this.chart_request.dst_min = "0";
          break;
      }
    },
    validateForm() {
      let result = true;

      this.errors.name_error = this.chart_request.title === "" ? "block" : "none";
      this.errors.time_error_h = this.chart_request.hour === null ? true : false;
      this.errors.time_error_m = this.chart_request.min === null ? true : false;
      this.errors.date_error_y = this.chart_request.year === null ? true : false;
      this.errors.date_error_d = this.chart_request.day === null ? true : false;
      this.errors.date_error_m = this.chart_request.month === null ? true : false;
      this.errors.location_error =
        this.chart_request.longitude === null ? "#EC221F" : "transparent";

      const requiredFields = [
        this.chart_request.title,
        this.chart_request.hour,
        this.chart_request.year,
        this.chart_request.month,
        this.chart_request.day,
        this.chart_request.longitude,
        // this.chart_request.gender,
      ];

      for (const field of requiredFields) {
        if (field === "" || field === null) {
          result = false;
          break;
        }
      }

      return result;
    },

    resetFormErrors() {},
    showFormErrors() {},
    submitChart() {
      // return this.test_submitChart();
      // console.log(this.auto_location);
      if (this.auto_location == false) {
        this.chart_request.latitude = HelperLib.convertDMSToDegree(
          this.chart_request.lat_deg,
          this.chart_request.lat_min,
          this.chart_request.lat_sec,
          this.chart_request.lat_dir
        );
        this.chart_request.longitude = HelperLib.convertDMSToDegree(
          this.chart_request.lon_deg,
          this.chart_request.lon_min,
          this.chart_request.lon_sec,
          this.chart_request.lon_dir
        );
        if (this.auto_timezone) {
          this.handlerNearestTimezone();
        }
      }
      if (this.validateForm()) {
        this.isLoading = true;
        ApiService.MakeReportOrder(this.chart_request ,  this.chart_type).then((response) => {
          this.isLoading = false;
          window.location.replace(response["data"]["pre_order"]);
        });
      }
    },
    search(input) {
      return new Promise((resolve) => {
        let url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&city=${encodeURI(
          input
        )}`;

        // console.log(this.only_county);
        if (this.only_county) {
          url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&country=${encodeURI(
            input
          )}`;
        }
        if (input.length < 3) {
          return resolve([]);
        }
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            resolve(data.features);
          });
      });
    },
    getResultValue(result) {
      let _c = result["properties"]["address"]["country"]
        ? result["properties"]["address"]["country"]
        : "بدون کشور";
      let _m = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"]
        ? result["properties"]["address"]["region"]
        : "";
      let _ci = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"]
        ? result["properties"]["address"]["hamlet"]
        : "";
      let _vi = result["properties"]["address"]["town"]
        ? result["properties"]["address"]["town"]
        : "";

      return result["properties"]['name'] + " - " + _m + " - " + _c;
    },
    handleSubmit(result) {
      // console.log(result);
      this.chart_request.longitude = result["geometry"]["coordinates"][0];
      this.chart_request.latitude = result["geometry"]["coordinates"][1];
      this.chart_request.tz_country = result["properties"]["address"]["country_code"];
      this.chart_request.city = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"];
      this.chart_request.state = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"];
      this.chart_request.display_loc = result["properties"]['display_name']
      this.chart_request.country = result["properties"]["address"]["country"];

      const lon_dms = HelperLib.convertDegreeToDMS(this.chart_request.longitude, true);
      const lat_dms = HelperLib.convertDegreeToDMS(this.chart_request.latitude);

      this.input_lon_deg = lon_dms["deg"];
      this.chart_request.lon_deg = this.input_lon_deg;

      this.chart_request.lon_dir = lon_dms["dir"];

      if (lon_dms["min"].toString().charAt(0) === "-") {

        this.input_lon_min = lon_dms["min"].toString().substring(1, 3);
      } else {

        this.input_lon_min = lon_dms["min"].toString();
      }
      this.chart_request.lon_min = lon_dms["min"];
      this.chart_request.lon_sec = lon_dms["sec"];
      this.chart_request.lat_dir = lat_dms["dir"];
      this.input_lat_deg = lat_dms["deg"];
      this.chart_request.lat_deg = this.input_lat_deg;

      if (lat_dms["min"].toString().charAt(0) === "-") {
        this.input_lat_min = lat_dms["min"].toString().substring(1, 3);
      } else {
        this.input_lat_min = lat_dms["min"].toString();
      }

      this.chart_request.lat_min = this.input_lat_min;
      this.chart_request.lat_sec = lon_dms["sec"];

      const year = this.chart_request.year;
      const day = this.chart_request.day;
      const month = this.chart_request.month;
      const date_type = this.chart_request.date_type;
      if (date_type !== "gregorian" && this.chart_request.country === "Iran" ||
        this.chart_request.country === "iran" ||
        this.chart_request.country === "ایران") {

        let dst_hour = "0";
        let dst_min = "0";
        let alert_type = 'default';
        let alert_text = null;

        let gregorianYear;
        if (month === 6 && day === 31 && year >= 1371) {
          console.log("The Hsahrivar Restrictions Worked")
          dst_hour = "0";
          dst_min = "0";
          alert_type = 'default';
          alert_text = null;
        } else {

          console.log("else The Hsahrivar Restrictions Worked")

        if (year < 1700) {
          gregorianYear = jalaali.toGregorian(year, month, 1).gy;
        } else {
          gregorianYear = year;
        }
        if (month <= 6) {

          if ((year >= 1356 && year <= 1401) || (gregorianYear >= 1977 && gregorianYear <= 2021)) {
            if (gregorianYear === 1977 && month >= 11) {
              dst_hour = "0.5";
              dst_min = "0";
              alert_text = 'ساعت DST به 0.5 به روز شد';
            } else if (gregorianYear === 1978) {
              if (month <= 6) {
                dst_hour = "1";
                // alert_text = 'ساعت DST به 1 به روز شد';
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
              } else if (month > 6) {
                dst_hour = "0.5";
                // alert_text = 'ساعت DST به 0.5 به روز شد';
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
              }
              dst_min = "0";
            } else if (gregorianYear === 1979 || gregorianYear === 1980) {
              if (month <= 6) {
                dst_hour = "1";
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
                // alert_text = 'ساعت DST به 1 به روز شد';
              } else {
                dst_hour = "0";
                dst_min = "0";
                alert_text = 'ساعت DST به 0 به روز شد';
              }
            } else if ((gregorianYear >= 1992 && gregorianYear <= 2005) || gregorianYear >= 2008) {
              if (month <= 6) {
                dst_hour = "1";
                // alert_text = 'ساعت DST به 1 به روز شد';
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
              } else {
                dst_hour = "0";
                dst_min = "0";
                alert_text = 'در زمان تولد شما ساعت روشنایی وجود داشته است و در محاسبات اعمال شده است';
                // alert_text = 'ساعت DST به 0 به روز شد';
              }
            }
            alert_type = 'updated';
          }
        }

        }

        this.chart_request.dst_hour = dst_hour;
        this.chart_request.dst_min = dst_min;
        this.chart_request.alert_type = alert_type;
        this.chart_request.alert_text = alert_text;
      }
      this.handlerNearestTimezone();
    },
    handlerNearestTimezone() {
      let request = {
        latitude: this.chart_request.latitude,
        longitude: this.chart_request.longitude,
        tz_country: this.chart_request.tz_country,
      };

      if (this.chart_request.tz_country == 'ir'){
        this.chart_request.timezone = "+03:30";
      } else {
        HelperLib.showLoading();
        this.isLoading = true;
        ApiService.getNearestTimezone(request).then((response) => {
          this.chart_request.timezone = response["data"][1];
          this.isLoading = false;
          // console.log(response);
          HelperLib.hideLoading();
        });
      }

    },
  },
};
</script>


<style scoped>
.chart-datepicker > input {
  background: #eee;
}
</style>
